import React from 'react'
import { Redirect } from '@reach/router'

export const PrivateRoute = ({ component : Component, user, isAuth, redirect, field, ...rest }) => {
  return (
    <>
    { isAuth && field in user ?
     <Component {...rest}/>
     :
     <Redirect from="/" to={redirect} noThrow/>
    }
    </>
  )
}